import { render, staticRenderFns } from "./AppAflossenHypotheekdeelList.vue?vue&type=template&id=386acfd6&scoped=true&"
import script from "./AppAflossenHypotheekdeelList.ts?vue&type=script&lang=ts&"
export * from "./AppAflossenHypotheekdeelList.ts?vue&type=script&lang=ts&"
import style0 from "./AppAflossenHypotheekdeelList.scss?vue&type=style&index=0&id=386acfd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386acfd6",
  null
  
)

export default component.exports